import { __assign } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { httpPost } from '@office-start/xhr-service';
import { MyDrivePath } from '../models/Constants';
import { getFileLocation } from '../utilities/getFileLocation';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
import { logUploadFeature } from '../utilities/logUploadFeature';
export function createUploadSession(graphXhrOptions, file, sessionId, parent, path, setAutoTranscribePreferHeader, driveId) {
    if (!file || !file.name) {
        return Promise.reject({
            clientError: 'Invalid file',
        });
    }
    var apiPath = "".concat(getFileLocation({
        drivePath: driveId ? 'drives/' + driveId + '/' : MyDrivePath,
        file: file,
        parent: parent,
        path: path,
    }), "createUploadSession");
    var url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, apiPath);
    var requestConfig = {
        method: "POST" /* HttpRequestMethod.Post */,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    if (setAutoTranscribePreferHeader) {
        requestConfig.headers['Prefer'] = 'autoTranscribe';
    }
    var postBody = {
        item: {
            '@microsoft.graph.conflictBehavior': 'rename',
        },
    };
    return new Promise(function (resolve, reject) {
        httpPost(KnownInstrumentationEvents.OneDriveGraphCreateUploadSessionRequest, "OneDrive_Graph_Create_Upload_Session" /* KnownRequestInstrumentationEvents.OneDriveGraphCreateUploadSessionRequest */, url, postBody, requestConfig, graphXhrOptions.jwtAuthEnabled || false, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
            populateRequestEvent: function (response, params) {
                var otelParams = __assign({}, params);
                otelParams["TotalSize" /* InstrumentationParam.TotalSize */] =
                    file.size.toString();
                logUploadFeature("OneDrive_Graph_Create_Upload_Session" /* KnownRequestInstrumentationEvents.OneDriveGraphCreateUploadSessionRequest */, sessionId, response, otelParams);
            },
        })
            .then(function (response) {
            var session = response.data;
            if (session && session.uploadUrl) {
                resolve(session);
            }
            else {
                reject({
                    clientError: 'Could not parse upload session from Graph response',
                });
            }
        })
            .catch(function (error) {
            getErrorHandler().handleError(error, "Nt3wB" /* ErrorId.Nt3wB */);
            reject(error);
        });
    });
}
//# sourceMappingURL=createUploadSession.js.map